var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9492 12.6328C17.9492 17.1892 14.2556 20.8828 9.69922 20.8828C5.14287 20.8828 1.44922 17.1892 1.44922 12.6328C1.44922 8.07646 5.14287 4.38281 9.69922 4.38281C14.2556 4.38281 17.9492 8.07646 17.9492 12.6328ZM16.4492 12.6328C16.4492 8.90489 13.4271 5.88281 9.69922 5.88281C5.9713 5.88281 2.94922 8.90489 2.94922 12.6328C2.94922 16.3607 5.9713 19.3828 9.69922 19.3828C13.4271 19.3828 16.4492 16.3607 16.4492 12.6328ZM4.44922 12.6328L5.94922 12.6328C5.94922 10.5617 7.62815 8.88281 9.69922 8.88281L9.69922 7.38281C6.79972 7.38281 4.44922 9.73332 4.44922 12.6328ZM11.9492 12.6328C11.9492 13.8755 10.9419 14.8828 9.69922 14.8828C8.45658 14.8828 7.44922 13.8755 7.44922 12.6328C7.44922 11.3902 8.45658 10.3828 9.69922 10.3828C10.9419 10.3828 11.9492 11.3902 11.9492 12.6328ZM9.69922 11.8828C10.1134 11.8828 10.4492 12.2186 10.4492 12.6328C10.4492 13.047 10.1134 13.3828 9.69922 13.3828C9.285 13.3828 8.94922 13.047 8.94922 12.6328C8.94922 12.2186 9.285 11.8828 9.69922 11.8828Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1872 2.63477V1.63477H16.1872H14.8122H13.8122V2.63477V4.61393H11.833H10.833V5.61393V6.98893V7.98893H11.833H13.8122V9.9681V10.9681H14.8122H16.1872H17.1872V9.9681V7.98893H19.1663H20.1663V6.98893V5.61393V4.61393H19.1663H17.1872V2.63477Z",
    fill: "#1B0076",
    stroke: "#F2F5F7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAlbum);
export default __webpack_public_path__ + "static/media/add-album.41315f7c.svg";
export { ForwardRef as ReactComponent };